import { Component, NgZone, OnInit } from '@angular/core';
import mdcAutoInit from '@material/auto-init';
import { MDCRipple } from '@material/ripple';
import { MDCTextField } from '@material/textfield';
import { AuthService } from '../services/auth.service';
import * as firebase from 'firebase';
import { Roles } from '../models/Roles';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { FgpasswordComponent } from '../fgpassword/fgpassword.component';

import { GoogleAuthService } from "./../google-auth.service";

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  email: string;
  password: string;
  errorMessage: string;
  constructor(
    public auths: AuthService,
    public router: Router,
    public ng: NgZone,
    public dialog: MatDialog,
    public gas: GoogleAuthService
  ) {
    this.email = '';
    this.password = '';
    this.errorMessage = '';
  }

  ngOnInit() {
    this.auths.user.subscribe((user) => {
      if (user !== null && user !== undefined) {
        const db = firebase.firestore();
        db.collection('users').where('uid', '==', user.uid).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.determineRoute(doc.data()['role'], user);
          });
        });
      }
    });
    const emailSignin = new MDCTextField(document.querySelector('.email-signin'));
    const passwordSignin = new MDCTextField(document.querySelector('.password-signin'));
    const selector = '.mdc-button, .mdc-icon-button, .mdc-card__primary-action';
    const ripples = [].map.call(document.querySelectorAll(selector), function (el) {
      return new MDCRipple(el);
    });

    this.errorAuthSub();
  }

  signIn() {
    this.gas.gapi_Load().then(() => {
      this.auths.login(this.email, this.password)
    })
  }

  determineRoute(role: any, user: any) {
    if (role === Roles.consultant) {
      this.ng.run(() => this.router.navigateByUrl('search/' + user.uid + '/' + user.email + '/' + role)).then(() => {
        location.reload();
      });
    } else {
      this.ng.run(() => this.router.navigateByUrl('home')).then(() => {
        location.reload();
      });
    }
  }

  errorAuthSub() {
    this.auths.errorAuth.subscribe((error) => {
      this.errorMessage = error;
    });
  }

  navigateToFGPass() {
    const dialogRef = this.dialog.open(FgpasswordComponent, {
      width: '350px',
      data: null
    });
  }
}
